export default {
    parts: ['spinner', 'button', 'iconSolid', 'iconOutline', 'count'],
    baseStyle: (props) => ({
        spinner: {
            display: props?.isHovered || !props?.isDesktop ? 'block' : 'none'
        },
        button: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            minWidth: '16px',
            variant: 'unstyled'
        },
        iconSolid: {
            width: '20px',
            height: '20px',
            display: props?.isHovered || !props?.isDesktop ? 'inline' : 'none'
        },
        iconOutline: {
            width: '20px',
            height: '20px',
            display: props?.isHovered || !props?.isDesktop ? 'inline' : 'none'
        },
        count: {
            display: props?.isHovered || !props?.isDesktop ? 'block' : 'none',
            textStyle: 'bodyXsRegular',
            marginLeft: 1
        }
    }),
    variants: {
        QuickView: {
            spinner: {
                display: 'block'
            },
            iconSolid: {
                display: 'inline'
            },
            iconOutline: {
                display: 'inline'
            },
            count: {
                display: 'block',
                textStyle: 'labelSm',
            }
        }
    }
}
